/* eslint-disable react-hooks/rules-of-hooks */
"use client"
import "./style.scss";
import CDNImage from "@/components/cdnImage/cdnImage";
import UKTitleBar from "@/components/UKTitleBar";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useTranslation } from "@/i18n/client";
import Effect from "./Effect";
import { Button } from "@mui/material";
import { uaParse } from "@/intl-jdi-common-ssr/utils/uaParser";
export default function Page(referrer: any) {

  const refer = referrer.searchParams.referrer;
  const imgUrl = "https://st.joy-sourcing.com/website/other/interruption.png";
  const router = useRouter();
  const { t } = useTranslation();
  useEffect(() => {
    window.history.replaceState(null, "", refer);
  }, [])

  // 返回上一页
  const toBack = () => {
    router.back();
  };
  // 判断是否在App内, 从路由中获取source参数-- IOS支付的webview不能写入自定义浏览器信息
  const isInJoybuyApp = referrer.searchParams.source === "APP";

  return (
    <>
      {
        !isInJoybuyApp ?
          <div className="interruption">
            <UKTitleBar toBack={toBack} />
            <div className="frame">
              <CDNImage src={imgUrl} width={200} height={200} alt="interruption" />
              <div className="title">{t("error403.text1")}</div>
              <div className="desc">{t("error403.text2")}</div>
              <a href={refer}>{t("error403.btn")}</a>
            </div>
            <Effect referrer={refer} />
          </div> :
          <Forbidden403ForApp />}
    </>
  );
}

/**
 * 
 *  app内web view限制只能跳转第三方支付页面，如银行。
 *  不能跳转其他页面，如果跳转其他页面，需要补充拦截页面（本次拦截页面）--后端接口直接重定向到这个页面
 *  定义一个Forbidden403ForApp函数，用于显示App 403错误页面
 *  
 */
const Forbidden403ForApp = () => {
  // 使用useTranslation函数获取翻译函数t
  const { t } = useTranslation();
  // 定义图片链接
  const imgUrl = "https://st.joy-sourcing.com/website/home/forbidden.png"


  const { isAndroid, isIOS } = uaParse(); // 获取当前浏览器信息, 判断是在IOS还是安卓内

  const backToJoybuyApp = () => {
    if (isAndroid) {
      window?.CallNative?.closeCurrentWeb();
      return;
    }
    if (isIOS) {
      window.location.href = "myapp://close";
      return;
    }
  }
  return <div className="forbidden403Page">
    <CDNImage src={imgUrl} width={120} height={120} alt="forbidden" />
    <div className="contentTipBox">{t("error403.app.contentTip")}</div>
    <Button variant="outlined" className="btnTextBox"
      onClick={backToJoybuyApp}
    >{t("error403.app.btnText")}</Button>
  </div>
}
